import React from "react";

export const PlusIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10 2C9.44772 2 9 2.44772 9 3L9 9L3 9C2.44772 9 2 9.44772 2 10C2 10.5523 2.44772 11 3 11L9 11L9 17C9 17.5523 9.44772 18 10 18C10.5523 18 11 17.5523 11 17L11 11L17 11C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9L11 9L11 3C11 2.44772 10.5523 2 10 2Z" fill="#F2F2F3" />
  </svg>
);
